(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .constant('PlanTypes', {
            master: 'plan',
            child: 'child-plan',
            template: 'template-plan',
            soop: 'soop-plan'
        })
        .factory('PlanTypesUtils', PlanTypesUtils);

    PlanTypesUtils.$inject = ['PlanTypes'];

    function PlanTypesUtils(PlanTypes) {
        
        return {
            getPlanType: getPlanType,
        };

        function getPlanType(type) {
            return PlanTypes[type.toLowerCase()];
        }
    }
})();
